// extracted by mini-css-extract-plugin
module.exports = {"table":"cookie-policy-table_table__Q_iBR","small":"cookie-policy-table_small__Ybnag"};